import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    common: {
      available_new_version: {
        available_new_version: 'AVAILABLE_NEW_VERSION',
      },
    },
  }));
}
